module.exports = __webpack_public_path__ + "static/media/drag-city-race.47b320ad.jpg";